/**
 * movimientoTicketCopy.ts — Títulos y etiquetas canónicas de comprobantes de movimiento.
 */

import type { MovimientoCaja } from "../types/caja.types";
import { isMovimientoAbonoCredito } from "../utils/movimientoAbonoCredito";

export type MovimientoReversalBanner =
  | "DEVOLUCION"
  | "DEVOLUCION_PARCIAL"
  | "VENTA_ANULADA"
  | "ANULACION_PARCIAL";

export const MOVIMIENTO_TICKET_FOOTER = {
  gestionadoCon: "Gestionado con",
  marca: "ALTENOT",
  avisoLegal: "Comprobante oficial no editable",
} as const;

export function movimientoTicketTitulo(mov: MovimientoCaja): string {
  if (isMovimientoAbonoCredito(mov)) return "Comprobante de Abono a Crédito";
  const map: Record<MovimientoCaja["tipo"], string> = {
    retiro: "Comprobante de Retiro",
    gasto: "Comprobante de Gasto",
    ingreso: "Comprobante de Ingreso",
    devolucion: "Comprobante de Devolución",
    anulacion: "Comprobante de Anulación",
    abrir_caja: "Comprobante de Apertura de Caja",
  };
  return map[mov.tipo] ?? "Comprobante de Movimiento";
}

export function movimientoTicketTipoLinea(mov: MovimientoCaja): string {
  if (isMovimientoAbonoCredito(mov)) return "Abono a Crédito";
  const map: Record<MovimientoCaja["tipo"], string> = {
    retiro: "Retiro",
    gasto: "Gasto",
    ingreso: "Ingreso",
    devolucion: "Devolución",
    anulacion: "Anulación",
    abrir_caja: "Apertura de caja",
  };
  return map[mov.tipo] ?? mov.tipo;
}

export function movimientoReversalBannerLabel(
  banner: MovimientoReversalBanner,
): string {
  const map: Record<MovimientoReversalBanner, string> = {
    DEVOLUCION: "DEVOLUCIÓN",
    DEVOLUCION_PARCIAL: "DEVOLUCIÓN PARCIAL",
    VENTA_ANULADA: "VENTA ANULADA",
    ANULACION_PARCIAL: "ANULACIÓN PARCIAL",
  };
  return map[banner];
}

export const ANULACION_SIN_REEMBOLSO_NOTA =
  "Corrección de registro — no implica reembolso al cliente.";

export const DEVOLUCION_REF_NOTA =
  "Este movimiento se generó al registrar una devolución de venta.";

export const DEVOLUCION_STOCK_NOTA =
  "Stock de estos productos fue restaurado automáticamente.";
